module.exports = __webpack_public_path__ + "static/img/1.4aa22a6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/shop/product/1.jpg
// module id = V9Fi
// module chunks = 1